import { createApp } from 'vue'
import App from '@/App.vue'
import _ from "lodash";
import store from '@/store'
import router from '@/router'
import VueCookies from 'vue3-cookies'
import $ from 'jquery' // 프로젝트 경로에서 설치 npm install jquery
import mitt from 'mitt'
import globalMethods from '@/utils/globalMethods.js'
import { WebUtil } from '@/utils/webUtil.js'
import VueSweetAlert from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import baseMixins from './views/common/mixins/baseMixins.vue'
import './assets/css/content/common_content.css';

// 날짜 안되면 다시 넣기 path
//npm install --save-dev @types/node

/**
 * vue3-cookies
 * npm install vue-cookies
 * https://www.npmjs.com/package/vue3-cookies
 */

/**
 * vue3-datepicker
 * npm install vue3-datepicker --save
 * https://www.npmjs.com/package/vue3-datepicker
 * import Datepicker from '../src/datepicker/Datepicker.vue'
    components: {
        Datepicker
    },
 */

/**
 * npm install jquery
 */

/**
 * npm i jquery-ui
 */

/**
 * Vue 3 Datepicker 적용버전
 * https://vue3datepicker.com
 * npm install vue3-date-time-picker --save
 */

/**
 * npm install vue3-loading-overlay -> npm install --save vue-loading-overlay
 * https://moyoujun.github.io/vue3-loading-overlay/ 
 * components/loading.vue
 */

/**
 * https://www.npmjs.com/package/vue-confirm-dialog
 */
 
/**
 * progress 두개를 모두 해야 하는 것 같음(현재 sb-admin-2가 bootstrap이라서 충돌이 됨. progressVue에서 import 주석처리함)
 * npm i bootstrap
 * npm i bootstrap-vue-3
 * https://www.npmjs.com/package/bootstrap-vue-3
 */
import { BootstrapVue3 } from 'bootstrap-vue-3'

/**
 * npm install chart.js @j-t-mcc/vue3-chartjs
 * https://vuejsexamples.com/a-simple-chartjs-wrapper-for-vue3/
 * https://www.chartjs.org/docs/latest/getting-started/usage.html
 * 
 * 도넛라벨
 * npm i chartjs-plugin-doughnutlabel-v3
 * https://www.npmjs.com/package/chartjs-plugin-doughnutlabel-v3
 */

/**
 * npm install v3-infinite-loading
 */

/**
 * 이벤트 버스
 * npm install --save mitt
 * https://zincod.tistory.com/237
 */


/**
 * swiper
 * npm i swiper
 * https://swiperjs.com/vue
 */
window.$ = $;
window.jQuery = $;
const emitter = mitt();

const app = createApp(App);
app.config.globalProperties.$store = store;
app.config.globalProperties._ = _;
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.WebUtil = WebUtil;

app.use(router);
app.use(store);
// app.use(emitter);
// app.use(VueCookies, {
//     // expireTimes: 60 * 60 * 24 * 30, // 1달
//     // maxAge: 60*60*24*30,
//     expireTimes: "30d",
//     path: "/",
//     secure: true,
//     sameSite: "None"
// });
app.use(BootstrapVue3);
app.use(globalMethods);
app.use(VueSweetAlert);
app.mixin(baseMixins);

app.mount('#app');